<template>
  <div class="view-modal-body">
		<div class="store-name" v-if="!isAdd">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<span>{{customerName}}</span>
		</div>
    <ul class="header">
      <span v-if="isAdd">
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<li
				v-for="item in urlMaps"
				:key="item.url"
				@click="componentSwitch(item.url)"
				:class="{ active : active === item.url }"
			>{{item.name}}</li>
		</ul>
		<!-- <div class="container">
			<customerInfo v-if="active === urlMaps[0].url"/>
			<paySet v-if="active === urlMaps[1].url"/>
		</div> -->
		<router-view class="view-content"></router-view>
    </div>
</template>

<script>
// import customerInfo from '@/views/index/src/customer/src/customerInfo.vue'
// import paySet from '@/views/index/src/customer/src/paySet.vue'

export default {
	name: 'viewModal',
	components: {
		// customerInfo, paySet

	},
	props: {
		productId: String,
		goodsId: String
	},
	data () {
		return {
			urlMaps: [
				{ name: '客户信息', url: '/main/customerView/customerInfo' },
				{ name: '附属账号', url: '/main/customerView/subsidiaryAccount' },
				{ name: '客户门店支付设置', url: '/main/customerView/paySetNew' },
				// { name: '客户专用价格', url: '/main/customerView/customerPrice' },
				{ name: '客户与商品关系', url: '/main/customerView/relationship' },
				{ name: '客户订货周期', url: '/main/customerView/orderScheme' },
				{	name: '信用额度', url: '/main/customerView/creditLimit' }
			],
			active: '/main/customerView/customerInfo',
			isAdd: false,
			customerName: ''
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '5-1')
		let hashArr = location.hash.split('/')
		let a = hashArr[hashArr.length - 1]
		this.active = '/main/customerView/' + a
		this.customerName = window.sessionStorage.getItem('customerName')
		if (window.sessionStorage.getItem('customerid') === '') {
			this.isAdd = true
		} else {
			this.isAdd = false
		}
	},
	methods: {
		goBack () {
			this.$router.push('/main/customer')
		},
		componentSwitch (url) {
			if (url !== 'customerInfo') {
				if (window.sessionStorage.getItem('customerid') === '') {
					this.$message.error('客户信息未编辑')
					return false
				} else {
					this.active = url
					this.$router.push(url)
					window.sessionStorage.setItem('type', url)
				}
			} else {
				this.active = url
				this.$router.push(url)
				window.sessionStorage.setItem('type', url)
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.view-modal-body {
	display flex
	flex: 1
	flex-direction column
	min-height: 0
	overflow: hidden
	.store-name {
		border-bottom: 1px solid #dce2fd;
		height:66px;
		min-height: 66px;
		line-height: 66px;
		box-sizing border-box
		span {
			font-size: 18px;
			font-weight: bold
			float left
			display inline-block
			line-height 66px
			padding-right 20px
			i {
				border-radius 50%
				cursor pointer
				background: #9da6af
				padding: 3px
			}
			.el-icon-back:before {
				content: "\E6EA"
				color: #fff
				font-weight: bold
			}
		}
	}
	.header {
		border-bottom: 1px solid #dce2fd;
		min-height:48px;
		line-height: 48px;
		font-size: 16px;
		box-sizing border-box
		flex-shrink: 0
		li {
			margin-right 40px
			cursor pointer
			height: 100%
			box-sizing:border-box
			float left
			&.active {
				border-bottom: 3px solid var(--fx-primary-color);
				font-weight: bold
			}
		}
		span {
			float left
			display inline-block
			line-height 48px
			padding-right 20px
			i {
				border-radius 50%
				cursor pointer
				background: #9da6af
				padding: 4px
			}
			.el-icon-back:before {
				content: "\E6EA"
				color: #fff
				font-weight: bold
			}
		}
	}
	.view-content {
		flex: 1
		min-height: 0
		overflow: hidden
		display: flex
		flex-direction: column
	}
	.container {
		height: 550px
		display flex
	}
}
</style>
